export const pick_data = 
{
  "picklists": [
    {
      "name": "Users",
      "masterkey": "user_id",
      "rows": [
        { "id": 1,"title": "Асеев А.С.","pkid": 3 },
        { "id": 2,"title": "Оскин А.А.","pkid": 4 },
        { "id": 3,"title": "Остренко С.А.","pkid": 5 },
        { "id": 4,"title": "Полежаева Л.В.","pkid": 7 },
        { "id": 5,"title": "Заикина К.Е.","pkid": 9 },
        { "id": 6,"title": "Максименко А.А.","pkid": 12 },
        { "id": 7,"title": "Янева Н.Н.","pkid": 11 },
      ]
    },
    {
      "name": "TypePort",
      "masterkey": "TypePort",
      "rows": [
        { "id": 1,"title": "Соломенная","pkid": 3 },
        { "id": 2,"title": "Деревянная","pkid": 4 },
        { "id": 3,"title": "Каменная","pkid": 5 },
      ]
    },
    {
      "name": "Vidp",
      "masterkey": "category_id",
      "rows": [
        {"id": 1,"title": "Плановая","pkid": 2 },
        {"id": 2,"title": "Внеплановая","pkid": 4 },
        {"id": 3,"title": "MFSM","pkid": 6 },
      ]
    }
  ],
  "is_error": 0,
  "error_text": "",
  "user_message_text": ""
}
